module.exports = __webpack_public_path__ + "static/media/cafe24-standoil6.9539ac7f.png";